export enum AdvertStatusEnum {
  Active = 1,
  Inactive,
  Expired,
  Ended,
  Count
}
